import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { CourseScheduleDetail, CourseScheduleFullDetail } from '../models/course-schedule-model';
import { ApiResponse } from '../../../models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class CourseScheduleService {
  private readonly http = inject(HttpClient);

  getSchedulesByCourseId(courseId: number): Observable<ApiResponse<CourseScheduleDetail[]>> {
    return this.http.get<ApiResponse<CourseScheduleDetail[]>>(
      `/api/v1/course-schedules/course/${courseId}`
    );
  }

  getScheduleById(idCourseSchedule: number): Observable<ApiResponse<CourseScheduleFullDetail>> {
    return this.http.get<ApiResponse<CourseScheduleFullDetail>>(
      `/api/v1/course-schedules/${idCourseSchedule}`
    );
  }
}
